// A2-558 — countries whose law lets a supplier not established there ask to
// pay the VAT itself instead of its business customer, keyed by country, with
// the hover text. Mirrors the art194.json cells carrying
// supplier_election_forces_local; tests/test_a2_558_se_goods_reverse_charge.py
// fails when the two disagree.
export const SUPPLIER_ELECTION = Object.freeze({
  SE: "Sweden, ML 16 kap. 7 §: by default a Swedish VAT-registered business customer "
    + "pays the VAT on goods (and property services) you sell it. Tick only if the "
    + "client asked Skatteverket to pay it itself, normally on its registration form.",
});
